import './withdrawal-summary.scss';

import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { Broadcaster } from '@core/app/scripts/services/broadcaster';
import { DisplayMessage } from '@core/app/scripts/services/display-message';
import { Mask } from '@core/app/scripts/services/mask';
import { Withdrawal } from '@shared/app/scripts/services/withdrawal';
import { WithdrawalSummary } from '@pos/app/scripts/services/withdrawal-summary';

/*
 * Component responsible for /withdrawal-summary route.
 */
angular
  .module('posApp')
  .directive(
    'withdrawalSummary',
    (
      broadcaster: Broadcaster,
      displayMessage: DisplayMessage,
      legacyPrint,
      mask: Mask,
      navigateTo: NavigateTo,
      pos,
      settingsManager,
      translate,
      withdrawal: Withdrawal,
      withdrawalSummary: WithdrawalSummary,
    ) => ({
      restrict: 'E',

      scope: true,

      template: require('./withdrawal-summary.html').default,

      link: function ($scope, element, attrs) {
        const $translate = translate;

        $scope.pos = pos;

        $scope.openEmailPopup = false;

        function printFailed() {
          mask.hide();
          displayMessage.message($translate.instant('PrintingNotPossible'));
        }

        $scope.navigateToView = (view) => {
          navigateTo(view);
        };

        $scope.transaction = angular.copy(withdrawalSummary.transaction);

        $scope.getHeadlineText = () => {
          let text = '';

          if (angular.isObject($scope.transaction)) {
            if ($scope.transaction.payments?.cash == 0) {
              text = $translate.instant('OpenDrawer');
            } else if ($scope.isWithdrawal()) {
              text = $translate.instant('Withdrawal');
            } else if (!$scope.isWithdrawal()) {
              text = $translate.instant('Deposit');
            }
          }

          return text;
        };

        $scope.getWithdrawalClass = () => {
          return {
            green: !$scope.isWithdrawal(),
            red: $scope.isWithdrawal(),
          };
        };

        $scope.isWithdrawal = () => {
          return $scope.transaction && $scope.transaction.payments?.cash < 0;
        };

        $scope.toggleEmailPopup = () => {
          $scope.withdrawalEmail = '';
          if (!settingsManager.settings.email.active) {
            displayMessage.message({
              message: $translate.instant('MissingEmailingModule'),
              type: 'info',
            });
            return;
          }

          broadcaster.send('setFocus', ['receiptEmail', true]);
          $scope.openEmailPopup = $scope.openEmailPopup ? false : true;
        };

        /*
         * Send the receipt re-print as an email
         */
        $scope.emailReceipt = () => {
          $scope.openEmailPopup = false;

          if ($scope.withdrawalEmail) {
            const callback = () => {
              navigateTo('pos.route#select-receipt');
            };

            withdrawal
              .email($scope.transaction._id, $scope.withdrawalEmail)
              .then(callback);
          } else {
            displayMessage.message($translate.instant('MissingEmailAddress'));
          }
        };

        // print the current transaction
        $scope.printReceipt = () => {
          displayMessage.showLoading();

          legacyPrint
            .withdrawal($scope.transaction, pos.config, true)
            .then($scope.navigateBack, printFailed);
        };

        $scope.navigateBack = () => {
          mask.hide();
          navigateTo(withdrawalSummary.fromPage);
        };
      },
    }),
  );
